<template>
  <table class="table table-bordered table-striped" style="table-layout: fixed">
    <thead>
      <tr>
        <th colspan="2">
          Metadados
          <span class="pull-right clickable show-more" @click="showRequestData = !showRequestData">{{!showRequestData ? 'Mostrar' : 'Esconder'}}</span>
        </th>
      </tr>
    </thead>
    <transition name="fade">
      <tbody v-if="showRequestData">
        <tr v-if="!isInvited">
          <td>Nome do Requisitante</td>
          <td>{{request.owner.name}}</td>
        </tr>
        <tr v-if="!isInvited">
          <td>Identificação</td>
          <td>{{request.owner.username}}</td>
        </tr>
        <tr>
          <td>Tipo</td>
          <td>{{request.reqType.name}}</td>
        </tr>
        <tr>
          <td>Status</td>
          <td>
            <request-status :status="request.status">
            </request-status>
          </td>
        </tr>
        <tr>
          <td>Última Atualização</td>
          <td>{{formatDate(request.updatedAt)}}</td>
        </tr>
        <tr>
          <td>Criação</td>
          <td>{{formatDate(request.createdAt)}}</td>
        </tr>
      </tbody>
    </transition>
  </table>
</template>

<script>
import RequestStatus from './util/RequestStatus'
import moment from 'moment'
moment.locale('pt-br')

export default {
  components: {
    RequestStatus
  },
  props: ['request'],
  data () {
    return {
      showRequestData: false
    }
  },
  methods: {
    formatDate (date) {
      return moment(new Date(date)).fromNow()
    }
  }
}
</script>

<style lang="scss" scoped>
  $active: lighten(#4183c4, 10%);
  
  .clickable {
    color: $active;
    cursor: pointer;
  }
  .show-more {
    font-weight: normal;
  }
</style>



// WEBPACK FOOTER //
// RequestMetadata.vue?0da1e3ee